import { AppId } from '@inno-tools/container-bridge'

import { ContainerApiSuccessResponse } from '../../containerApi.types'

export interface GetAppsResponse
  extends ContainerApiSuccessResponse<
    Array<{
      id: string
      name: string
      label: string
      app_id: AppId
      slug: string
      show_application_permission: string
      is_permissioned: boolean
      is_locked: boolean
      is_spotlighted?: boolean
      created_at: string
      updated_at: string
    }>
  > {}
